import Vue from "vue";
import Vuelidate from "vuelidate";

import "./assets/scss/style.scss";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./plugins/base";
import { HttpPlugin, Http } from "./plugins/http";
import { DatePlugin } from "./plugins/date";
import { NotificationPlugin } from "./plugins/notifications/notification";
import { ConfigPlugin } from "@/plugins/config";
import { LightBoxPlugin } from "@/modules/light-box/light-box.plugin";
import { FeatureFlagsPlugin } from "@/plugins/feature-flags.plugin.js";
import "@/components/modals";
import router from "./router";
import { BusPlugin } from "@/plugins/bus.plugin.js";
import { UtilsPlugin } from "@/plugins/utils.plugin.js";
import { makeEchoPlugin } from "@/core/echo/echo.plugin.js";
import { loadRuntimeConfig, applyBrandingToDom } from "@/services/runtime-config";

import { CityReference } from "@/core/references/city";
import { ClinicsReference } from "@/core/references/clinics";
import { CountryReference } from "@/core/references/country";
import { DoctorCategoriesReference } from "@/core/references/doctor-categories";
import { DoctorEducationsReference } from "@/core/references/doctor-educations";
import { LanguagesReference } from "@/core/references/languages/languages.reference";
import { PrivacyParametersReference } from "@/core/references/privacy-parameters";
import { ScientificDegreesReference } from "@/core/references/scientific-degrees";
import { SpecializationsReference } from "@/core/references/specializations";
import { StreetReference } from "@/core/references/street";
import { UniversitiesReference } from "@/core/references/universities";
import { SexReference } from "@/core/references/sex";
import { ScheduleRepository } from "@/modules/common-schedule/schedule.repository";
import { Registry } from "@/core/Registry";
import { VueMaskDirective } from "v-mask";

(async () => {
  await loadRuntimeConfig();
  applyBrandingToDom();

  Vue.config.productionTip = false;

  // Активация плагинов
  Vue.use(BusPlugin);
  Vue.use(UtilsPlugin);
  Vue.use(HttpPlugin);
  Vue.use(DatePlugin);
  Vue.use(Vuelidate);
  Vue.use(NotificationPlugin);
  Vue.use(ConfigPlugin);
  Vue.use(LightBoxPlugin);
  Vue.use(FeatureFlagsPlugin);
  Vue.directive("mask", VueMaskDirective);

  // Service Registry
  const serviceRegistry = new Registry();
  serviceRegistry.set(CityReference, new CityReference(Http));
  serviceRegistry.set(ClinicsReference, new ClinicsReference(Http));
  serviceRegistry.set(CountryReference, new CountryReference(Http));
  serviceRegistry.set(DoctorCategoriesReference, new DoctorCategoriesReference(Http));
  serviceRegistry.set(DoctorEducationsReference, new DoctorEducationsReference(Http));
  serviceRegistry.set(LanguagesReference, new LanguagesReference(Http));
  serviceRegistry.set(PrivacyParametersReference, new PrivacyParametersReference());
  serviceRegistry.set(ScientificDegreesReference, new ScientificDegreesReference(Http));
  serviceRegistry.set(SexReference, new SexReference(Http));
  serviceRegistry.set(SpecializationsReference, new SpecializationsReference(Http));
  serviceRegistry.set(StreetReference, new StreetReference(Http));
  serviceRegistry.set(UniversitiesReference, new UniversitiesReference(Http));
  serviceRegistry.set(ScheduleRepository, new ScheduleRepository(Http));

  Vue.use({
    install(Vue) {
      Vue.prototype.$registry = serviceRegistry;
    },
  });

  // Получение глобальных GET параметров
  const urlParams = new URLSearchParams(window.location.search);

  const die = (text: string) => {
    alert(text);
    window.stop();
    throw new Error(text);
  };

  const saveParam = (paramName: string, storePath: string) => {
    if (urlParams.has(paramName)) {
      const paramValue = urlParams.get(paramName);
      if (paramValue === null || !Number.isInteger(Number(paramValue))) {
        die(`GET параметр "${paramName}" указан не корректно, должен быть валидным числом`);
      } else {
        localStorage.setItem(paramName, paramValue);
        store.commit(storePath, paramValue);
      }
    } else {
      const savedParamValue = localStorage.getItem(paramName);
      if (savedParamValue !== null) {
        store.commit(storePath, savedParamValue);
      }
    }
  };

  // Обрабатываем параметры customer_id и doctor_id
  saveParam("customer_id", "customer/SET_ID");
  saveParam("doctor_id", "auth/SET_ID");

  if (urlParams.has("hash")) {
    console.info("Attempt login by hash");
    await store.dispatch("auth/loadByHash", {
      hash: urlParams.get("hash"),
    });
  } else {
    await store.dispatch("auth/loadToken");
    await store.dispatch("auth/loadProfile");
  }

  if (store.state.auth.id !== store.state.customer.id) {
    await store.dispatch("auth/loadProfile");
  }

  Vue.use(makeEchoPlugin(store));

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),

    async created() {
      if (this.$store.state.auth.profile) {
        this.$store.commit("auth/SET_ID", this.$store.state.auth.profile.id);
      } else {
        this.$router.push({ name: "login" });
      }
      if (this.$store.state.customer.id) {
        await this.$store.dispatch("customer/loadProfile", this.$store.state.customer.id);
      }

      if (urlParams.has("hmenu")) {
        this.$store.commit("HIDE_DRAWER");
      }

      if (urlParams.has("hideMenu")) {
        this.$store.commit("SET_DRAWER", false);
      }
    },
  }).$mount("#app");
})();
